import CategoryColor from '../schema/CategoryColor';
import { ColorScheme } from 'mini-color-utils/lib/ColorScheme';
import { DEFAULT_CATEGORY_COLOR_CODE } from '../schema/categoriesConstants';
import { generateColorScheme } from 'mini-color-utils/lib/colorUtils';

/**
 * Get the color schemes for categories
 * Note: When dark mode is supported in mini, memoization should be done based on mode
 */
let categoryColorSchemes = null;
export const getCategoriesColorSchemes = (): { [key: string]: ColorScheme } =>
    categoryColorSchemes ||
    (categoryColorSchemes = {
        [CategoryColor.None]: generateColorScheme('#000000'),
        [CategoryColor.Red]: generateColorScheme('#E74856'),
        [CategoryColor.Orange]: generateColorScheme('#FF8C00'),
        [CategoryColor.Peach]: generateColorScheme('#FFAB45'),
        [CategoryColor.YellowLight]: generateColorScheme('#FFF100'),
        [CategoryColor.GreenLight]: generateColorScheme('#47D041'),
        [CategoryColor.TealLight]: generateColorScheme('#30C6CC'),
        [CategoryColor.Olive]: generateColorScheme('#73AA24'),
        [CategoryColor.BlueSky]: generateColorScheme('#00BCF2'),
        [CategoryColor.PurpleLight]: generateColorScheme('#8764B8'),
        [CategoryColor.Pink]: generateColorScheme('#F495BF'),
        [CategoryColor.SteelLight]: generateColorScheme('#A0AEB2'),
        [CategoryColor.SteelGrey]: generateColorScheme('#004B60'),
        [CategoryColor.GreyLight]: generateColorScheme('#B1ADAB'),
        [CategoryColor.GreyDark]: generateColorScheme('#5D5A58'),
        [CategoryColor.Black]: generateColorScheme('#000000'),
        [CategoryColor.RedDark]: generateColorScheme('#750B1C'),
        [CategoryColor.OrangeDark]: generateColorScheme('#CA5010'),
        [CategoryColor.BrownMedium]: generateColorScheme('#AB620D'),
        [CategoryColor.YellowDark]: generateColorScheme('#C19C00'),
        [CategoryColor.GreenDark]: generateColorScheme('#004B1C'),
        [CategoryColor.TealDark]: generateColorScheme('#004B50'),
        [CategoryColor.OliveDark]: generateColorScheme('#0B6A0B'),
        [CategoryColor.BlueDark]: generateColorScheme('#002050'),
        [CategoryColor.PurpleDark]: generateColorScheme('#32145A'),
        [CategoryColor.MagentaDark]: generateColorScheme('#5C005C'),
    });

/**
 * Gets the default category color scheme
 */
export const getDefaultCategoryColorScheme = (): ColorScheme =>
    getCategoriesColorSchemes()[DEFAULT_CATEGORY_COLOR_CODE];
